import React from 'react'

class Page404 extends React.Component {
  render() {
    return (
      <div className="page404">
        <img src="images/404.png" alt="Erreur 404" />
        <p><b>Cette page n'existe pas</b></p>
        <p>Désolé, vous êtes dans la bonne agence, <br/>mais pas à la bonne adresse</p>
        <p><a href={ process.env.PUBLIC_URL + "/" } class="button">Accueil</a></p>
      </div>
    )
  }
}

export default Page404



// WEBPACK FOOTER //
// ./src/containers/Page404.jsx